import React, { Component }  from 'react';
import { Row, Col, Select, Radio, Input, Upload, Icon, message } from 'antd'

import NewRadio from '../radio';
import { QINIU_DOMAIN, getQiniuTokenAPI } from '@/API';
import { OPTION_INPUT_TYPE, LETTER_MAP } from '../../constData';
import Editor from '@/entry_question_editor/question/common/editor';
import { getToolbars } from '@/utils/questionManageType';

// 参数
const Option = Select.Option;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;

class OptionEditor extends Component {

    state = {
        uptoken: '',
    }

    componentDidMount() {
		getQiniuTokenAPI({}).then((res) => {
            const { uptoken } = res.data;
            this.setState({uptoken})
        })
    }
    // 选项个数发生变化
    handleOptionChange = num => {
        const { onOptionChange } = this.props;
        onOptionChange && onOptionChange(num);
    }

    // 内容输入方式改变
    onContentInputStyleChange = num => {
        const { onContentInputStyleChange } = this.props;
        onContentInputStyleChange && onContentInputStyleChange(num)
    }

    // 选项答案发生变化
    onRadioChange = e => {
        const { onRadioChange } = this.props;
        onRadioChange && onRadioChange(e)
    }

    // 改变文本款内容
    handleTextContent = (e, i) => {
        const { optionList, onEdittStemList } = this.props;
        const newOptionList = [...optionList];
        newOptionList[i] = Object.assign( {}, newOptionList[i], {
           textArea: e.target.value
        });
        onEdittStemList && onEdittStemList({optionList: newOptionList});
    }

    // 上传音频成功
    handleUploadChange = (data, i) => {
        const { optionList, onEdittStemList } = this.props;
        const newOptionList = [...optionList];
        if(data.file.status=='uploading'){
            // 上传中
        }else if(data.file.status=='done'){
            // 上传成功
            let fileUrl = `${QINIU_DOMAIN}${data.file.response.key}`;
            newOptionList[i] = Object.assign(newOptionList[i], {
                audio: fileUrl
            })
            onEdittStemList && onEdittStemList({optionList: newOptionList});
        }else {
            // 上传失败
        }
    }

    // 上传图片
    handleUploadImgChange = (data, i) => {
        const { optionList, onEdittStemList } = this.props;
        const newOptionList = [...optionList];
        if(data.file.status=='uploading'){
            // 上传中
        }else if(data.file.status=='done'){
            // 上传成功
            let fileUrl = `${QINIU_DOMAIN}${data.file.response.key}`;
            newOptionList[i] = Object.assign(newOptionList[i], {
                img: fileUrl
            })
            onEdittStemList && onEdittStemList({optionList: newOptionList});
        }else {
            // 上传失败
        }
    }

    handleBeforeUpload = file => {
        const isJPG = (file.type === 'audio/mp3'||file.type === 'audio/mpeg');
        const isLt20M = file.size / 1024 / 1024 <= 20;

        if (!isJPG) {
            message.error('音频格式支持mp3');
        }
        
        if (!isLt20M) {
            message.error('音频的最大尺寸不能超过20M');
        }
        return isJPG && isLt20M;
    }

    renderAnswer = () => {
        const { currentOptionNum, rightAnswer } = this.props;
        let answerList = [];

        for (let i = 0; i < currentOptionNum; i++) {
            answerList.push(<Radio key={i} value={LETTER_MAP[i]}>{LETTER_MAP[i]}</Radio>)
        }

        return (
            <RadioGroup onChange={this.onRadioChange} value={rightAnswer}>
                {answerList}
            </RadioGroup>
        )  
    }

    renderAnswerContent = () => {
        const { currentOptionNum, optionInputWay, subject, optionList } = this.props;
        const optionContent = [];
        let { uptoken } = this.state;

        const uploadProps={
            data:{
                token: uptoken
            },
            action:"//up.qbox.me/",
            showUploadList: false
        }

        for (let i = 0; i < currentOptionNum; i++) {
            optionContent.push(
                <Row className="content-tml-row-public" type="flex" align="middle" key={i}>
                    <Col span={2} className="content-tml-public-name">{`${LETTER_MAP[i]}：`}</Col>
                    <Col span={20}>
                        <div className="option-select-content">
                            <div className="textarea-input" style={{display: optionInputWay === 'text' ? 'block' : 'none'}}>
                                <TextArea value={optionList[i].textArea} autosize={{ minRows: 2 }} onChange={(e) => this.handleTextContent(e, i)} />
                            </div>
                            <div className="editor-container"  style={{display: optionInputWay === 'rich_text' ? 'block' : 'none'}}>
                                <Editor id={`option_template_${i+1}`}  toolbar={getToolbars(subject,'stem')}/>
                            </div>
                            <div style={{display: optionInputWay === 'image' ? 'block' : 'none'}}>
                                <div className="upload-image">
                                    <Upload 
                                        {...uploadProps}
                                            accept="img/*"
                                            onChange={data => this.handleUploadImgChange(data, i)}
                                        >
                                        <div className="upload-img-icon">
                                            <Icon type="upload" />
                                        </div>
                                    </Upload>
                                    <span className="accept-type">*&nbsp;支持png、jpg类型</span>
                                    <div className="img-display">
                                        <img title="预览图片" src={optionList[i].img.length > 0 ? optionList[i].img : 'static/img/default_img.png'} />
                                    </div>
                                </div>
                            </div>
                            <div style={{display: optionInputWay === 'audio' ? 'block' : 'none'}}>
                                <div className="upload-audio" >
                                    <Upload 
                                        {...uploadProps}
                                            accept="audio/*"
                                            beforeUpload={this.handleBeforeUpload}
                                            onChange={data => this.handleUploadChange(data, i)}
                                        >
                                        <div className="upload-audio-icon">
                                            <Icon type="upload" />
                                        </div>
                                    </Upload>
                                    <span className="accept-type">*&nbsp;音频格式为mp3，20M上线</span>
                                    <div className="audio-display">
                                        {
                                            optionList[i].audio.length > 0 ? <audio src={optionList[i].audio} controls="controls">您的浏览器不支持</audio> : <Icon type="sound" />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            )
        }

        return (optionContent)
    }
    
    render() {
        const { currentOptionNum, maxOptionNum, optionInputWay } = this.props;

        return (
            <div>
                <Row className="content-tml-row-public" type="flex" align="middle">
                    <Col span={2} className="content-tml-public-name">选项个数：</Col>
                    <Col span={22} className="option-detail">
                        <NewRadio
                            optionNum={currentOptionNum}
                            maxOptionNum={maxOptionNum}
                            onOptionChange={this.handleOptionChange}
                        />
                        <div className="content-in-style">
                            <label>内容录入方式：&nbsp;&nbsp;</label>
                            <Select 
                                style={{width: '120px'}}
                                value={optionInputWay}
                                onChange={this.onContentInputStyleChange}
                            >
                                {
                                    OPTION_INPUT_TYPE.map((item, index) => 
                                        <Option value={item.text} key={index}>{item.name}</Option>
                                    )
                                }
                            </Select>
                        </div>
                    </Col>
                </Row>
                <Row className="content-tml-row-public" type="flex" align="middle">
                    <Col span={2} className="content-tml-public-name">答案：</Col>
                    <Col span={22}>
                        {this.renderAnswer()}
                    </Col>
                </Row>
                {this.renderAnswerContent()}
            </div>
        )
    }
}

export default OptionEditor;


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/components/option_editor/view.js